import { useEffect } from 'react';

import {
	ANALYTICS_OPERATIONAL_ACTION,
	ANALYTICS_UI_SUBJECT,
} from '../../constants/snippetAnalytics.ts';
import {
	setOnFetchComplete,
	type FetchPerformanceMetrics,
} from '../../store/actions/fetchActions.ts';

import { useSnippetAnalytics } from './useSnippetAnalytics.ts';

/**
 * Registers an analytics callback for snippet fetch performance metrics.
 *
 * Fires an operational event after each successful fetch with:
 * snippetCount, userScopeCount, globalScopeCount, payloadSizeBytes, durationMs.
 *
 * Call this from a component that is mounted before fetchSnippets() runs
 * (e.g. SnippetsProvider).
 */
export const useSnippetsFetchAnalytics = () => {
	const { fireOperationalAnalytic } = useSnippetAnalytics();

	useEffect(() => {
		setOnFetchComplete((metrics: FetchPerformanceMetrics) => {
			fireOperationalAnalytic({
				actionSubject: ANALYTICS_UI_SUBJECT.SNIPPETS,
				action: ANALYTICS_OPERATIONAL_ACTION.FETCHED,
				attributes: metrics,
			});
		});

		return () => setOnFetchComplete(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
